import React from "react";
import { LayoutMain } from "../../../../boxes/LayoutMain/LayoutMain";
import styles from "./styles.module.scss";
import { Header } from "./shared/Header";
import { Box } from "../../../../shared/Box/Box";
import { Filter } from "./shared/Filter";
import { Table } from "./shared/Table";
import { useDocuments } from "./hooks/useDocuments";
import { useMultiselectEntity } from "../../../../utilities/hooks/useMultiselectEntity";
import { useCurrentUserQuery } from "../../../../api/queries/useUserQuery";
import { PERMISSIONS } from "../../../../consts/api";
import { isFileManagementAllowed } from "./utilities";

export function PatientDocuments() {
  var { documents, order, search, period, filter } = useDocuments();
  var { data: user } = useCurrentUserQuery();
  var permissions = user?.privileges || [];
  var canMutate = permissions.includes(PERMISSIONS.patientDocuments.mutate);
  var canView = permissions.includes(PERMISSIONS.patientDocuments.view);

  var selection = useMultiselectEntity({
    allEntities: documents.value
      .filter(
        (x) =>
          (canMutate || canView) &&
          isFileManagementAllowed(x.name, permissions),
      )
      .map((x) => x.id),
  });

  return (
    <LayoutMain>
      <div className={styles.root}>
        <Header
          selection={selection}
          permissions={{
            canMutate,
            canView,
          }}
        />
        <Box className={styles.content}>
          <Filter
            search={search}
            filter={filter}
            period={period}
            docTypes={documents.docTypes}
          />
          <Table
            documents={documents}
            order={order}
            selection={selection}
            permissions={{
              canMutate,
              canView,
              values: permissions,
            }}
          />
        </Box>
      </div>
    </LayoutMain>
  );
}
